/* eslint import/no-webpack-loader-syntax: off */
import React, { useState } from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import {
  ContactFormWrapper,
  ContactForm,
  ConctactIcons,
  ContactIcon,
  ResultMessage,
  FormGroup,
  FormLabel,
  FormInput,
  FormTextArea,
  FormSubmit,
} from './Contacts/ContactForm';
import IconInstagram from '-!react-svg-loader!../assets/svg/instagram.svg';
import IconTelegram from '-!react-svg-loader!../assets/svg/telegram_.svg';

const initialFormData = {
  firstName: '',
  firstNameError: '',
  lastName: '',
  lastNameError: '',
  email: '',
  emailError: '',
  message: '',
  messageError: '',
};

const fields = ['firstName', 'lastName', 'email', 'message'];

const Contacts = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [result, setResult] = useState(null);
  const {
    firstName,
    lastName,
    email,
    message,
    firstNameError,
    lastNameError,
    emailError,
    messageError,
  } = formData;

  const handleChange = ({ target: { name, value } }) =>
    setFormData((data) => ({ ...data, [name]: value, [`${name}Error`]: '' }));

  const handleValidate = () => {
    let isValid = true;
    Object.keys(formData).forEach((key) => {
      if (fields.includes(key)) {
        if (!formData[key]) {
          setFormData((data) => ({ ...data, [`${key}Error`]: 'Is required' }));
          isValid = false;
        }
      }
    });
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (handleValidate()) {
      try {
        await axios.post(
          '/api/submit',
          {
            firstName,
            lastName,
            email,
            message,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        setResult(true);
      } catch (error) {
        setResult(false);
      }
    }
  };

  return (
    <ContactFormWrapper>
      <ConctactIcons>
        <ContactIcon
          href='https://www.instagram.com/fialkovskaia_yulia/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <IconInstagram />
        </ContactIcon>
        <ContactIcon
          href='https://t.me/fialkovskaia'
          target='_blank'
          rel='noopener noreferrer'
        >
          <IconTelegram />
        </ContactIcon>
      </ConctactIcons>
      {result !== null ? (
        result ? (
          <ResultMessage>
            <FormattedMessage
              id='app.contacts.resultSuccess'
              defaultMessage='Thank you, your message has been sent'
            />
          </ResultMessage>
        ) : (
          <ResultMessage>
            <FormattedMessage
              id='app.contacts.resultError'
              defaultMessage='Error, the message has not been sent'
            />
          </ResultMessage>
        )
      ) : (
        <ContactForm onSubmit={handleSubmit}>
          <FormGroup>
            <FormLabel>
              <FormattedMessage
                id='app.contacts.firstName'
                defaultMessage='Name'
              />{' '}
              *
            </FormLabel>
            <FormInput
              name='firstName'
              value={firstName}
              onChange={handleChange}
              autoComplete='off'
              error={firstNameError}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              <FormattedMessage
                id='app.contacts.lastName'
                defaultMessage='Surname'
              />{' '}
              *
            </FormLabel>
            <FormInput
              name='lastName'
              value={lastName}
              onChange={handleChange}
              autoComplete='off'
              error={lastNameError}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              <FormattedMessage
                id='app.contacts.email'
                defaultMessage='Email'
              />{' '}
              *
            </FormLabel>
            <FormInput
              name='email'
              value={email}
              type='email'
              onChange={handleChange}
              autoComplete='off'
              error={emailError}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              <FormattedMessage
                id='app.contacts.message'
                defaultMessage='Message'
              />{' '}
              *
            </FormLabel>
            <FormTextArea
              name='message'
              value={message}
              rows={5}
              onChange={handleChange}
              error={messageError}
            />
          </FormGroup>
          <FormSubmit type='submit'>
            <FormattedMessage
              id='app.contacts.submit'
              defaultMessage='Submit'
            />
          </FormSubmit>
        </ContactForm>
      )}
    </ContactFormWrapper>
  );
};

export default Contacts;
